module.exports = __webpack_public_path__ + "static/media/building1.42f762c7.png";